import { takeLatest, put, select } from 'redux-saga/effects';
import { deletePostAcqTasks, setPostAcqWorkflowLoadingOverlayState, appNotify, setPostAcqUWClientTask } from 'store/actions';
import { userSelector } from 'store/selectors';
import { postWithToken } from 'api/network';

export function* deletePostAcqTasksSaga() {
	yield takeLatest(deletePostAcqTasks, function* ({ payload: taskIds }) {
		try {
			const user = yield select(userSelector);
			yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: true, message: 'Deleting...' }));
			const res = yield postWithToken(`/api/postAcquisition/tasks/delete?requestUserId=${user.id}`, taskIds);
			const deletedTxnOppIds = yield res.json();

			// clear selectedTxnOpp
			yield put(setPostAcqUWClientTask(null))
		} catch (error) {
			yield put(appNotify(error.message, 'error'));
		}
		finally {
			yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
		}
	});
}
